import { useFetchPost } from "custom_hooks/Actions"
import { useEffect, useState } from "react"
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';

const path = process.env.REACT_APP_PATH;
const domain = process.env.REACT_APP_DOMAIN

export default function DirectDownloadReport(){
    var apYear = localStorage.getItem("apYear")
    const history = useHistory();

    let fetchData = useFetchPost(window.location.toString().split(path)[0] + path + "/api/AppraisalModule/appraisal.php?action=getDataBasedOnYear",{ aYear: apYear })

    function parseCustomData(dt){
        console.log("parseData", dt)
        dt = dt.trim()
        dt = dt.replaceAll(/[^\B\s+|\s+\Ba-z0-9:",.{}-]/gi, '')
        dt = JSON.parse(dt)
       
       return dt
   }

   useEffect(()=>{
    if(fetchData.status === "fetched"){
        if(fetchData.data[0] === 0){
            Swal.fire(
                "Data Not Found",
                "No data found for selected year. Please try another year. ",
                // json[1],
                // json[0] === 1 ? "success" : "error"
            );
        }else{
            generateExcelReport(fetchData.data)
            Swal.fire(
                "Data Found",
                "The data will be downloaded shortly...",
                // json[1],
                // json[0] === 1 ? "success" : "error"
            );
        }
        history.push(path + "/report")
    }

   }, [fetchData])

    function generateExcelReport(fetched){

          // Data preparation
        //   const title = "Staff Appraisal Report";
          const headers = [
              "Employee Code",
              "Appraisal Status",
              "Name",
              "Department",
              "Position",
              "Join Date",
              "Length of Service",
              "Manager",
              "Overall Performance",
              "Manager's Comment",
          ];
  
          // Construct the worksheet data
          const worksheetData = [
            //   [title], // Title row
              headers, // Headers row
          ];
  
          // Adding data rows
          fetched.map((dt) => {
              if (dt && dt !== null) {
                  let pDt = null;
                  let supervisorComment = "N.A";
                  let overallMarking = "N.A";
  
                  if (dt["otherComment"] && dt["otherComment"] !== null) {

                      pDt = parseCustomData(dt["otherComment"]);

                      supervisorComment = pDt["managerComment"] === null ? "N.A" : pDt["managerComment"];

                      overallMarking = pDt["overallMarking"] === null ? "N.A" : pDt["overallMarking"];
                      if(overallMarking == 1){
                          overallMarking = 'Unsatisfactory';
                      }if(overallMarking == 2){
                          overallMarking = 'Less than satisfactory';
                      }if(overallMarking == 3){
                          overallMarking = 'Satisfactory';
                      }if(overallMarking == 4){
                          overallMarking = 'More than satisfactory';
                      }if(overallMarking == 5){
                          overallMarking = 'Well ahead of standard';
                      }
                  }
  
                  const todayDate = new Date();
                  const firstJoin = new Date(dt["JoinDate"]);
                  const lengthServiceMonth = todayDate.getMonth() - firstJoin.getMonth() + 12 * (todayDate.getFullYear() - firstJoin.getFullYear());
                  const lengthServiceYear = Math.floor(lengthServiceMonth / 12);
                  const actualMonth = lengthServiceMonth % 12;
  
                  const inputDataForServerDuration = `${lengthServiceYear} Years ${actualMonth} Months`;
  
                  worksheetData.push([
                      dt["aOwner"],
                      dt["aStatus"],
                      dt["aName"],
                      dt["department"],
                      dt["designation"],
                      dt["JoinDate"],
                      inputDataForServerDuration,
                      dt["reportManagerName"],
                      overallMarking,
                      supervisorComment,
                  ]);
              }
          });


           // Convert data to worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData.slice(1)); // Skip header row

        // Initialize merges array if not present
        worksheet["!merges"] = [];

        // Step 1: Merge the main title across all header columns
        const totalColumns = 9 * 2 + 5; // 9 fields with 2 columns each + 5 columns for Manager's Comment
        const totalRows = worksheetData.length + 1; // Add 1 for the header
        worksheet["!ref"] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: totalRows, c: totalColumns - 1 } });

        // Step 2: Merge all columns for the main title
        worksheet["!merges"].push({
            s: { r: 0, c: 0 },
            e: { r: 0, c: totalColumns - 1 },
        });

        worksheet["A1"] = { 
            v: "Staff Appraisal Report For the Year Of 2024", 
            s: { alignment: { horizontal: "center", vertical: "center" }, font: { bold: true, size: 25 } } 
        };

        // Step 3: Merge and set data for each of the first 9 fields
        for (let i = 0; i < 9; i++) {
            const startCol = i * 2; // Start column for the current field
            const endCol = startCol + 1; // End column for the current field

            // Merge columns for header row (title and value)
            worksheet["!merges"].push({
                s: { r: 1, c: startCol },
                e: { r: 1, c: endCol },
            });

            // Merge data cells for each row (title and value)
            worksheetData.forEach((row, rowIndex) => {
                const dataRow = rowIndex + 2; // Offset by 2 for title and headers
                const dataCell = XLSX.utils.encode_cell({ r: dataRow, c: startCol });
                worksheet[dataCell] = { 
                    v: row[i], // Set the value from worksheetData
                    s: { alignment: { vertical: "center",  horizontal: "center", wrapText: true } } 
                };

                // Merge the data cells
                worksheet["!merges"].push({
                    s: { r: dataRow, c: startCol },
                    e: { r: dataRow, c: endCol },
                });
            });
        }

        // Step 4: Merge and set data for "Manager's Comment"
        const managerColStart = 9 * 2; 
        const managerColEnd = managerColStart + 4; // End column (5 columns total)

        // Merge Manager's Comment header
        worksheet["!merges"].push({
            s: { r: 1, c: managerColStart },
            e: { r: 1, c: managerColEnd },
        });
       

        // Merge and set data rows for Manager's Comment
        worksheetData.forEach((row, rowIndex) => {
            const dataRow = rowIndex + 2; // Offset by 2 for title and headers
            const dataCell = XLSX.utils.encode_cell({ r: dataRow, c: managerColStart });
            worksheet[dataCell] = { 
                v: row[9], // Assuming Manager's Comment is the 10th field in worksheetData
                s: { alignment: { vertical: "center",  horizontal: "center", wrapText: true } } 
            };

             // Adjust row height for wrapping (optional based on data)
            if (!worksheet["!rows"]) worksheet["!rows"] = [];
            worksheet["!rows"][dataRow] = { hpt: 15 }; // Increase row height to accommodate wrapping (adjust as needed)

            worksheet["!cols"] = worksheet["!cols"] || [];
            for (let col = managerColStart; col <= managerColEnd; col++) {
                worksheet["!cols"][col] = { wch: 15 }; // Adjust width to 30 (adjust as needed)
            }

            // Merge the data cells
            worksheet["!merges"].push({
                s: { r: dataRow, c: managerColStart },
                e: { r: dataRow, c: managerColEnd },
            });
        });

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Staff Appraisal 2024");

        // Generate Excel file
        const fileName = `staffAppraisal${apYear}.xlsx`;
        XLSX.writeFile(workbook, fileName);

        // Clean up local storage if needed
        localStorage.removeItem("apYear");




  
        //   // Convert data to worksheet
        //   const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  
        //   // Merge title across all header columns
        //   worksheet["!merges"] = [
        //       { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }, // Merge the title row
        //   ];
  
        //   // Apply borders and center alignment for all cells
        //   const range = XLSX.utils.decode_range(worksheet["!ref"]);
        //   for (let row = range.s.r; row <= range.e.r; row++) {
        //       for (let col = range.s.c; col <= range.e.c; col++) {
        //           const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
        //           if (!worksheet[cellAddress]) continue; // Skip if no cell exists
  
        //           // Set style with borders and alignment
        //           worksheet[cellAddress].s = {
        //               border: {
        //                   top: { style: "thin", color: { rgb: "000000" } },
        //                   bottom: { style: "thin", color: { rgb: "000000" } },
        //                   left: { style: "thin", color: { rgb: "000000" } },
        //                   right: { style: "thin", color: { rgb: "000000" } },
        //               },
        //               alignment: { vertical: "center", horizontal: "center" },
        //               font: row === 0 || row === 1 ? { bold: true } : {}, // Bold title and headers
        //           };
        //       }
        //   }
  
        //   // Create a new workbook and append the worksheet
        //   const workbook = XLSX.utils.book_new();
        //   XLSX.utils.book_append_sheet(workbook, worksheet, "Staff Appraisal");
  
        //   // Generate Excel file
        //   const fileName = `staffAppraisal${apYear}.xlsx`;
        //   XLSX.writeFile(workbook, fileName);
  
        //   // Clean up local storage if needed
        //   localStorage.removeItem("apYear");





//download as the pdf
        // var tb = new jsPDF('l', 'mm', [500, 500])

        // const ratingSelect = ["Unsatisfactory", "Less than satisfactory", "Satisfactory", "More than satisfactory", "Well ahead of standard"]
        
        // var tbData = [{
        //     col1: ratingSelect[0],
        //     col2: ratingSelect[1],
        //     col3: ratingSelect[2],
        //     col4: ratingSelect[3],
        //     col5: ratingSelect[4],

        // }]

        // autoTable(tb, {
        //     columnStyles:{
        //         col1: {fontStyle:'bold', halign:'center', valign: 'middle'}, 
        //         col2: {fontStyle:'bold', halign:'center', valign: 'middle'}, 
        //         col3: {fontStyle:'bold', halign:'center', valign: 'middle'}, 
        //         col4: {fontStyle:'bold', halign:'center', valign: 'middle'}, 
        //         col5: {fontStyle:'bold', halign:'center', valign: 'middle'},  
        //         // col11: {fontStyle:'bold', cellWidth: 100},
        //     },
        //     headStyles:{
        //         halign: "center",
        //         fillColor: "#7FFFD4",
        //         textColor: "black"
        //     },
        //     body: tbData,
        //     columns: [
        //         { header: "1", dataKey:'col1'},
        //         { header: "2", dataKey:'col2'},
        //         { header: "3", dataKey:'col3'},
        //         { header: "4", dataKey:'col4'},
        //         { header: "5", dataKey:'col5'},
        //     ]
        // })
        
        // var data = []
        // fetched.map((dt)=>{
        //     if(dt && dt !== null){
        //         console.log("DT", dt)
        //         let pDt = null
        //         var supervisorComment = "N.A"
        //         var directorComment = "N.A"
    
        //         if(dt["otherComment"] && dt["otherComment"] !== null){
        //             pDt = parseCustomData(dt["otherComment"])
    
        //             supervisorComment = (pDt["managerComment"] === null ? "N.A" : pDt["managerComment"])
        //             // directorComment = (pDt["directorComment"] === null ? "N.A" : pDt["directorComment"])
        //         }
    
        //         var todayDate = new Date()
        //         var firstJoin = new Date(dt["JoinDate"])
    
        //         var lengthServiceMonth = todayDate.getMonth() - firstJoin.getMonth() + (12 * (todayDate.getFullYear() - firstJoin.getFullYear()))
        //         var lengthServiceYear = lengthServiceMonth / 12
        //         var actualMonth = lengthServiceMonth % 12
    
        //         var inputDataForServerDuration = parseInt(lengthServiceYear) + " Years " + parseInt(actualMonth) + " Months"
                
        //         data.push({
        //             col1: dt["aOwner"],
        //             col2: dt["aStatus"],
        //             col3: dt["aName"],
        //             col4: dt["department"],
        //             col5: dt["designation"],
        //             col6: dt["JoinDate"],
        //             col7: inputDataForServerDuration,
        //             col8: dt["reportManagerName"],
        //             col9: pDt === null ? "N.A" : ratingSelect[parseInt(pDt["overallMarking"])-1],
        //             col10: supervisorComment,
        //             // col11: directorComment
        //         })
        //     }else{

        //     }
        // })

        // autoTable(tb, {
        //     columnStyles:{
        //         col1: {fontStyle:'bold'}, 
        //         col2: {fontStyle:'bold'}, 
        //         col3: {fontStyle:'bold'}, 
        //         col4: {fontStyle:'bold'}, 
        //         col5: {fontStyle:'bold'}, 
        //         col6: {fontStyle:'bold'}, 
        //         col7: {fontStyle:'bold'}, 
        //         col8: {fontStyle:'bold'}, 
        //         col9: {fontStyle:'bold'}, 
        //         col10: {fontStyle:'bold', cellWidth: 100}, 
        //         // col11: {fontStyle:'bold', cellWidth: 100},
        //     },
        //     body: data,
        //     columns: [
        //         { header: "Employee Code", dataKey:'col1'},
        //         { header: "Appraisal Status", dataKey:'col2'},
        //         { header: "Name", dataKey:'col3'},
        //         { header: "Department", dataKey:'col4'},
        //         { header: "Position", dataKey:'col5'},
        //         { header: "Join Date", dataKey:'col6'},
        //         { header: "Length of Service as of "+apYear, dataKey:'col7'},
        //         { header: "Supervisor", dataKey:'col8'},
        //         { header: "Overall Performance", dataKey:'col9'},
        //         { header: "Supervisor's Comment", dataKey:'col10'},
        //         // { header: "Director's Comment", dataKey:'col11'},
        //     ]
        // })

        // tb.save('staffAppraisal' +apYear+ '.pdf')
        // localStorage.removeItem("apYear")

//download as the pdf










        // history.push(path + "/report")
        // console.log(reportData)
        // var data =[]
        // var header = ["EmployeeCode", "Appraisal Status", "Name", "Department", "Position", "Join Date", "Length of Service as of "+apYear, "Supervisor", "Overall Performance", "Supervisor's Comment", "Director's Comment"]

        // // data.push(header)

        // const ratingSelect = ["Unsatisfactory", "Less than satisfactory", "Satisfactory", "More than satisfactory", "Well ahead of standard"]

        // reportData.map((dt)=>{
        //     let pDt = parseCustomData(dt["otherComment"])
        //     var todayDate = new Date()
        //     var firstJoin = new Date(dt["JoinDate"])

        //     var lengthServiceMonth = todayDate.getMonth() - firstJoin.getMonth() + (12 * (todayDate.getFullYear() - firstJoin.getFullYear()))
        //     var lengthServiceYear = lengthServiceMonth / 12
        //     var actualMonth = lengthServiceMonth % 12

        //     var inputDataForServerDuration = lengthServiceYear + " Years " + actualMonth + " Months"

        //     // console.log(lengthServiceMonth)
        //     var supervisorComment = (pDt["managerComment"] === null ? "N.A" : pDt["managerComment"])
        //     var directorComment = (pDt["directorComment"] === null ? "N.A" : pDt["directorComment"])

        //     // data.push([dt["aOwner"], dt["aStatus"], dt["aName"], dt["department"], dt["designation"], dt["JoinDate"], lengthServiceYear + " Years " + actualMonth + " Months", dt["reportManagerName"], ratingSelect[parseInt(pDt["overallMarking"])], supervisorComment, directorComment])

        //     data.push([
        //         {value: dt["aOwner"], style: {font: {sz:"24", bold: true}}},
        //         {value: dt["aStatus"], style: {font: {sz:"24", bold: true}}},
        //         {value: dt["aName"], style: {font: {sz:"24", bold: true}}},
        //         {value: dt["department"], style: {font: {sz:"24", bold: true}}},
        //         {value: dt["designation"], style: {font: {sz:"24", bold: true}}},
        //         {value: dt["JoinDate"], style: {font: {sz:"24", bold: true}}},
        //         {value: inputDataForServerDuration, style: {font: {sz:"24", bold: true}}},
        //         {value: dt["reportManagerName"], style: {font: {sz:"24", bold: true}}},
        //         {value: dt["overallMarking"], style: {font: {sz:"24", bold: true}}},
        //         {value: supervisorComment, style: {font: {sz:"24", bold: true}}},
        //         {value: directorComment, style: {font: {sz:"24", bold: true}}},
        //     ])

            // Object.keys(dt).map((k)=>{
            //     console.log(k)
                // if(k === "otherComment"){
                //     directorComment =dt["directorComment"]
                //     supervisorComment = dt["managerComment"]
                //     // let pDt = parseCustomData(dt[k])

                //     // Object.keys(pDt).map((pK)=>{
                //     //     wholeSent += pK + ": " + pDt[pK] + "\r\n"
                //     // })

                //     // field.push(wholeSent)
                // }else{
                //     field.push(dt[k])
                // }
            // })
        // })

        // // Create a new workbook and worksheet
        // const workbook = XLSX.utils.book_new();
        // const worksheet = XLSX.utils.aoa_to_sheet(data);
    
        // // Add the worksheet to the workbook
        // XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // // Set the column widths (optional)
        // worksheet['!cols'] = [{ width: 20 }, { width: 20 }, { width: 20 },{ width: 20 },{ width: 25 },{ width: 20 },{ width: 30 },{ width: 20 },{ width: 20 },{ width: 20 },{ width: 20 },{ width: 20 },{ width: 20 },{ width: 20 }];

        // // Convert the workbook to a buffer
        // const buffer = XLSX.write(workbook, { type: 'buffer', bookType: 'xlsx' });
    
        // // Download the file using FileSaver.js
        // saveAs(new Blob([buffer]), "Staff_Appraisal - " +  apYear + ".xlsx");



        // downloadAsXLSX= () => {
        //     const date = this.getDate()
        //     // this.ref.table.download("xlsx", this.props.moduleName + "-" +  date + ".xlsx")
        //     const data = [];
        //     const header = [];
        //     const field = [];
        
        //     this.ref.state.columns.map(x=>{
        //         header.push(x['title']);
        //         field.push(x['field']);
        //     })
        //     data.push([this.props.moduleName,'',''])
        //     data.push([]);
        //     data.push(header);
        //     this.ref.state.data.map((x) =>{
        //         const row = [];
        //         field.map(f=>{
        //             row.push(x[f]);
        //         })
            
        //         data.push(row);
                
        //     })   
            
            
        //     // Create a new workbook and worksheet
        //     const workbook = XLSX.utils.book_new();
        //     const worksheet = XLSX.utils.aoa_to_sheet(data);
        
        //     // Add the worksheet to the workbook
        //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            
        //     // Set the column widths (optional)
        //     // worksheet['!cols'] = [{ width: 10 }, { width: 20 }, { width: 20 },{ width: 20 },{ width: 20 }];
            
        //     // Merge cells for the title row
        //     // worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 2 } }];
            
        //     //   Convert the workbook to a buffer
        //     const buffer = XLSX.write(workbook, { type: 'buffer', bookType: 'xlsx' });
            
        //     //   Download the file using FileSaver.js
        //     saveAs(new Blob([buffer]), this.props.moduleName + "-" +  date + ".xlsx");
    
        //     // XLSX.writeFile(workbook, this.props.moduleName + "-" +  date + ".xlsx");
        // }

    }

    return(
        <>
            {/* {fetchData.status === "fetched"?
                generateExcelReport()
            :
                <p>Loading...</p>
            } */}
        </>
    )   
}